import { useAppSelector } from "store/store";
import { BulkResizeState } from "store/features/bulkResize/types";
import { bulkResizeSelector } from "store/features/bulkResize/selectors/bulkResizeSelector";
import { useToggle } from "client/hooks/utils/useToggle";

export const useBulkResizeSettings = () => {
    const {
        resizeSettings: { dimensionType, unit },
    } = useAppSelector(bulkResizeSelector, equalityFn);
    const { isOpen: isExportSettingsOpen, toggle: toggleExportSettings } = useToggle(true);

    return { dimensionType, unit, isExportSettingsOpen, toggleExportSettings };
};

const equalityFn = (left: BulkResizeState, right: BulkResizeState) => {
    if (
        left.resizeSettings.dimensionType !== right.resizeSettings.dimensionType ||
        left.resizeSettings.unit !== right.resizeSettings.unit
    )
        return false;

    return true;
};
